import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound.tsx';
import { ProviderCreateForm } from '@openx/components-provider/lib/components/ProviderForm/ProviderCreateForm.tsx';
import { ProviderEditForm } from '@openx/components-provider/lib/components/ProviderForm/ProviderEditForm.tsx';
import type { ProvidersRouteParams } from '@openx/components-provider/lib/components/types.ts';
import { useProviderContext } from '@openx/components-provider/lib/utils/context/ProviderContext.tsx';
import { useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';

export const ProviderFormPage = () => {
  const { session } = useAuth();
  const { providerId = '' } = useParams<ProvidersRouteParams>();
  const { useProviderFetch } = useProviderContext();
  const { provider, loading } = useProviderFetch(providerId);

  const isAllowed = isAdmin(session);

  if (!isAllowed) return <AccessForbiddenPage />;

  if (loading) return <Loader />;

  if (!providerId) return <ProviderCreateForm />;

  if (!provider) {
    return <PageNotFound appName={'OpenXSelect'} />;
  }

  return <ProviderEditForm currentProvider={provider} />;
};
